import { Component, OnInit, Input } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'usb-item-ptheme',
  templateUrl: './item-ptheme.component.html',
  styleUrls: ['./item-ptheme.component.scss']
})
export class ItemPthemeComponent implements OnInit {

  @Input() 
  item : any;

  constructor() { }

  ngOnInit() {
  }

}
